import { forwardRef } from "react";

import IconType from "@/components/IconType";
import Stack from "@/tpo/Stack";

import { ReportListCardShell } from "./Card";
import { ReportListCardDescription } from "./Description";
import { ReportListCardHeader } from "./Header";
import { ReportListCardMarkersAssessed } from "./MarkersAssessed";
import { ReportListCardTitle } from "./Title";
import { getReportListCardVariantStyles } from "./variantStyles";

const ReportListCard = forwardRef(
  (
    {
      name,
      shortDescription,
      iconType,
      iconSize = [40, 40, 80],
      onClick,
      functionalDatapointCount,
      userReportFunctionalDatapointCount,
      dnaDatapointCount,
      userReportDnaDatapointCount,
      userReportSymptomsCount,
      symptomsCount,
      variant,
      topRightButton,
      showDescription = true,
      sx
    },
    ref
  ) => {
    const { bg, color, cursor, showMarkers } = getReportListCardVariantStyles(variant);

    return (
      <ReportListCardShell
        bg={bg}
        onClick={onClick}
        ref={ref}
        data-component-name="ReportListCard"
        cursor={cursor}
        px={[20, 20, 40]}
        {...sx}
      >
        <ReportListCardHeader
          iconType={iconType}
          iconSize={iconSize}
          topRightButton={topRightButton}
          color={color}
        />
        <Stack gap={16}>
          <ReportListCardTitle name={name} color={color} />
          {showDescription ? (
            <ReportListCardDescription shortDescription={shortDescription} color={color} />
          ) : null}
        </Stack>
        {showMarkers ? (
          <ReportListCardMarkersAssessed
            functionalDatapointCount={functionalDatapointCount}
            userReportFunctionalDatapointCount={userReportFunctionalDatapointCount}
            dnaDatapointCount={dnaDatapointCount}
            userReportDnaDatapointCount={userReportDnaDatapointCount}
            symptomsCount={symptomsCount}
            userReportSymptomsCount={userReportSymptomsCount}
            color={color}
            layout="stack"
            showCircleButton={variant !== "disabled"}
          />
        ) : null}
      </ReportListCardShell>
    );
  }
);

ReportListCard.Card = ReportListCardShell;
ReportListCard.Icon = IconType;

export default ReportListCard;
